// extracted by mini-css-extract-plugin
export default {"jobsToBeDone":"jobsToBeDone--3OO76","jobsToBeDoneCards":"jobsToBeDoneCards--1ftmV"};